import { useState, useEffect } from "react";
import Header from "../../header/Header";
import FadeIn from "../../../general/FadeIn";
import RoundedInput from "../../../general/RoundedInput";
import DateInput from "../../../general/DateInput";
import OrangeButton from "../../../general/OrangeButton";
import JazigoModal from "../../../general/JazigoModal";
import FalecidoDocumentsManager from "../../../general/FalecidoDocumentsManager";
import Api from "../../../../services/Api";

const labelStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  fontWeight: 600,
  color: "#888",
  marginBottom: 4,
  paddingLeft: 12,
  display: "block",
};

const sectionTitleStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 15,
  fontWeight: 700,
  color: "#555",
  marginBottom: 4,
  marginTop: 8,
};

const inputBase = {
  width: "100%",
  padding: "16px 28px",
  borderRadius: 40,
  border: "none",
  background: "#e8e8e8",
  fontSize: 16,
  fontFamily: "'DM Sans', sans-serif",
  color: "#666",
  outline: "none",
  boxSizing: "border-box",
  cursor: "pointer",
  textAlign: "left",
};

function UpdateBurialPage({ navigate, user, onLogout, selectedFalecido }) {
  const [sepultamentoId, setSepultamentoId] = useState(null);
  const [burialForm, setBurialForm] = useState({
    jazigo_id: null,
    data_sepultamento: "",
    funeraria: "",
    responsavel_sepultamento: "",
    ordem_no_jazigo: "",
  });
  const [jazigos, setJazigos] = useState([]);
  const [jazigoModalOpen, setJazigoModalOpen] = useState(false);
  const [selectedJazigo, setSelectedJazigo] = useState(null);
  const [loadingSepultamento, setLoadingSepultamento] = useState(true);
  const [popupError, setPopupError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Api.getJazigos()
      .then((geojson) =>
        setJazigos(
          geojson.features.map((f) => ({
            id: f.properties.id,
            codigo: f.properties.numero,
            quadra: f.properties.quadra,
          })),
        ),
      )
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!selectedFalecido?.id) { setLoadingSepultamento(false); return; }
    Api.getSepultamentosByFalecido(selectedFalecido.id)
      .then(async (sepultamentos) => {
        const sep = sepultamentos?.[0];
        if (!sep) { setLoadingSepultamento(false); return; }
        setSepultamentoId(sep.id);
        setBurialForm({
          jazigo_id: sep.jazigo_id ?? null,
          data_sepultamento: sep.data_sepultamento || "",
          funeraria: sep.funeraria || "",
          responsavel_sepultamento: sep.responsavel_sepultamento || "",
          ordem_no_jazigo: sep.ordem_no_jazigo != null ? String(sep.ordem_no_jazigo) : "",
        });
        if (sep.jazigo_id) {
          const jaz = await Api.getJazigo(sep.jazigo_id).catch(() => null);
          if (jaz) setSelectedJazigo({ id: jaz.id, codigo: jaz.numero || jaz.codigo, quadra: jaz.quadra });
        }
      })
      .catch(() => {})
      .finally(() => setLoadingSepultamento(false));
  }, [selectedFalecido]);

  const updateBurial = (field) => (e) =>
    setBurialForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleVoltar = () => navigate("search", { selectedFalecido });

  const handleSubmit = async () => {
    if (!burialForm.jazigo_id || !burialForm.data_sepultamento) {
      setPopupError("Jazigo e data de sepultamento são obrigatórios.");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        falecido_id: selectedFalecido.id,
        jazigo_id: burialForm.jazigo_id,
        data_sepultamento: burialForm.data_sepultamento,
        responsavel_sepultamento: burialForm.responsavel_sepultamento || null,
        funeraria: burialForm.funeraria || null,
        ordem_no_jazigo: burialForm.ordem_no_jazigo ? Number(burialForm.ordem_no_jazigo) : null,
      };
      if (sepultamentoId) {
        await Api.updateSepultamento(sepultamentoId, payload);
      } else {
        await Api.createBurial(payload);
      }
      navigate("search", { selectedFalecido });
    } catch (e) {
      setPopupError(e.message || "Erro ao atualizar sepultamento.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#fafafa",
      }}
    >
      {popupError && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 14,
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              padding: "32px 36px",
              maxWidth: 380,
              width: "90%",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <h3
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 18,
                fontWeight: 700,
                color: "#2d2d2d",
                marginBottom: 10,
              }}
            >
              Erro ao atualizar
            </h3>
            <p
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 15,
                color: "#666",
                marginBottom: 24,
              }}
            >
              {popupError}
            </p>
            <button
              onClick={() => setPopupError("")}
              style={{
                background: "linear-gradient(135deg, #F2A66C 0%, #E8956A 100%)",
                border: "none",
                color: "#fff",
                borderRadius: 8,
                padding: "10px 28px",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 15,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
      <JazigoModal
        isOpen={jazigoModalOpen}
        onClose={() => setJazigoModalOpen(false)}
        jazigos={jazigos}
        onSelect={(j) => {
          setSelectedJazigo(j);
          setBurialForm((prev) => ({ ...prev, jazigo_id: j.id }));
        }}
      />
      <Header
        onHome={() => navigate("search")}
        onLogin={() => navigate("login")}
        user={user}
        onLogout={onLogout}
        navigate={navigate}
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
        }}
      >
        <FadeIn delay={100}>
          <h1
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 32,
              fontWeight: 700,
              color: "#2d2d2d",
              textAlign: "center",
              marginBottom: 36,
            }}
          >
            Atualização de Sepultamento
          </h1>
        </FadeIn>

        {loadingSepultamento ? (
          <p style={{ fontFamily: "'DM Sans', sans-serif", color: "#aaa" }}>Carregando dados do sepultamento...</p>
        ) : (
          <div
            style={{
              width: "100%",
              maxWidth: 400,
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
          >
            <FadeIn delay={160}>
              <p style={{ ...sectionTitleStyle, marginTop: 16 }}>
                Dados do Sepultamento
              </p>
              <hr
                style={{
                  border: "none",
                  borderTop: "1px solid #e0e0e0",
                  marginBottom: 8,
                }}
              />
            </FadeIn>

            <FadeIn delay={220}>
              <button
                type="button"
                onClick={() => setJazigoModalOpen(true)}
                style={{
                  ...inputBase,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ color: selectedJazigo ? "#444" : "#bbb" }}>
                  {selectedJazigo
                    ? `Setor: ${selectedJazigo.quadra} - Número: ${selectedJazigo.codigo}`
                    : "Selecionar jazigo *"}
                </span>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  style={{ flexShrink: 0 }}
                >
                  <path
                    d="M2 4l4 4 4-4"
                    stroke="#aaa"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </FadeIn>

            <FadeIn delay={280}>
              <div lang="pt-BR">
                <label style={labelStyle}>Data do Sepultamento *</label>
                <DateInput
                  value={burialForm.data_sepultamento}
                  onChange={updateBurial("data_sepultamento")}
                />
              </div>
            </FadeIn>

            <FadeIn delay={340}>
              <div lang="pt-BR">
                <RoundedInput
                  placeholder="Funerária responsável"
                  type="text"
                  value={burialForm.funeraria}
                  onChange={updateBurial("funeraria")}
                />
              </div>
            </FadeIn>

            <FadeIn delay={400}>
              <RoundedInput
                placeholder="Responsável pelo sepultamento"
                value={burialForm.responsavel_sepultamento}
                onChange={updateBurial("responsavel_sepultamento")}
              />
            </FadeIn>

            <FadeIn delay={460}>
              <RoundedInput
                placeholder="Ordem no jazigo"
                type="number"
                value={burialForm.ordem_no_jazigo}
                onChange={updateBurial("ordem_no_jazigo")}
              />
            </FadeIn>

            <FadeIn delay={490}>
              <FalecidoDocumentsManager falecidoId={selectedFalecido?.id} />
            </FadeIn>

            <FadeIn delay={520}>
              <div style={{ textAlign: "center", marginTop: 20 }}>
                <OrangeButton onClick={handleSubmit} disabled={loading}>
                  {loading ? "Atualizando..." : "Atualizar"}
                </OrangeButton>

                <p
                  style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: 13,
                    color: "#999",
                    marginTop: 12,
                  }}
                >
                  (* Campos obrigatórios)
                </p>
                <p
                  style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: 14,
                    color: "#E8956A",
                    marginTop: 16,
                    cursor: "pointer",
                  }}
                  onClick={handleVoltar}
                >
                  Voltar
                </p>
              </div>
            </FadeIn>
          </div>
        )}
      </div>
    </div>
  );
}

export default UpdateBurialPage;
